import React, {Fragment} from 'react'
import AuthenticationService from "../services/AuthenticationService";
import SuggestedUsersUploader from '../components/SuggestedUsersUploader'
import SuggestedUsersTable from '../components/SuggestedUsersTable'
import {useRef, useEffect} from "react";
import apiRequest from "../services/apiRequest";
import {useState} from "react";
import {PageHeading} from "@ui-components/Container";
import {useIntl} from "react-intl";
import {getExcludeNullColumns} from "../utils/suggestedUsersTableUtils";

const SuggestedUsers = () => {
  const intl = useIntl();
  const userData = AuthenticationService.getUserData()
  const tableRef = useRef(null);
  const [importedFromOptions, setImportedFromOptions] = useState([]);
  const [importedFromRadioButtonOptions, setImportedFromRadioButtonOptions] = useState([]);
  const excludeNullsRef = useRef(getExcludeNullColumns(importedFromOptions)
    .reduce((acc, curr) => {
      return {...acc, [curr.field]: false}
    }, {}));
  useEffect(async () => {
    let importedSources = await apiRequest.get("/suggested_users/import_sources/all")
    setImportedFromRadioButtonOptions(importedSources.map((source) => {
      return {value: source.name, name: source.name}
    }))
    setImportedFromOptions(importedSources.map((source) => {
      return {value: source.name, label: source.name}
    }))
  }, []);
  return <>
    <PageHeading title={intl.formatMessage({id: "suggested_users"})}/>
    {userData.role_type === "admin" && importedFromRadioButtonOptions.length > 0 && <>
      <SuggestedUsersUploader
        tableRef={tableRef}
        importedFromOptions={importedFromRadioButtonOptions}
      />
      <hr className="my-8" />
    </>}
    {(userData.role_type === "admin" || userData.role_type === "field") && importedFromOptions.length > 0 && (
      <div className="mb-10">
        <SuggestedUsersTable
          tableRef={tableRef}
          importedFromOptions={importedFromOptions}
          excludeNullsRef={excludeNullsRef}
        />
      </div>
    )}
  </>
}

export default SuggestedUsers